/* src/app/shared/components/vocacao-table/vocacao-table.component.scss */
.panel-height {
  height: auto;
  padding: 1% 0;
}
.body-content-header {
  font-size: 16px;
  font-weight: 500;
  padding: 0px 56px 0 25px;
}
.body-title {
  text-decoration: none;
  font: normal normal normal 20px/26px Montserrat, sans-serif;
  letter-spacing: 0px;
  color: #2E3241;
}
.grey-bg {
  background-color: #fafafa !important;
}
.soft-grey-bg {
  background-color: #fdfdfd !important;
}
.soma {
  text-align: left;
  font: normal normal 600 20px/26px Montserrat, sans-serif;
  letter-spacing: 0px;
  color: #007AC2;
  font-weight: 600;
}
.box {
  max-height: 37vh;
  width: 100%;
  overflow: auto;
}
.vocacao-detail {
  min-width: 60%;
  max-width: 870px;
}
.vocacao-list {
  margin-top: 8px;
  margin-bottom: 8px;
}
.vocacao-list .vocacao-detail {
  margin: 1% auto;
  width: 90%;
  border: 1px solid #80BDE0;
  border-radius: 4px;
}
.vocacao-list .vocacao-detail .vocacao-detail-header {
  font-size: 16px;
  font-weight: 500;
  background: #80BDE0 0% 0% no-repeat padding-box;
}
.vocacao-list .vocacao-detail .vocacao-detail-header .vocacao-detail-header-margin {
  margin: 0.5% 2%;
}
.vocacao-list .vocacao-detail .vocacao-detail-body {
  font-size: 16px;
  font-weight: 500;
  color: #2E3241;
}
.vocacao-list .vocacao-detail .vocacao-detail-body .vocacao-detail-body-margin {
  margin: 0.5% 2%;
}
.data-vocacao-header {
  text-align: left;
  font: normal normal normal 12px/26px Montserrat, sans-serif;
  letter-spacing: 0px;
  color: #757575;
  text-transform: uppercase;
}
.representatividade-value {
  text-align: left;
  font: normal normal normal 20px/26px Montserrat, sans-serif;
  letter-spacing: 0px;
  color: #2E3241;
}
.header-table-detalhes-vocacao {
  text-align: center;
  color: #ffffff;
}
.soma-vocacoes-column {
  margin-right: 40px;
}
:host ::ng-deep .mat-checkbox-indeterminate.mat-accent .mat-checkbox-background,
:host ::ng-deep .mat-checkbox-checked.mat-accent .mat-checkbox-background {
  background-color: #007AC2 !important;
}
/*# sourceMappingURL=vocacao-table.component.css.map */
